import { map } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { branch, compose, lifecycle, renderNothing, withHandlers, withProps, withState } from 'recompose';
import { t } from '../../../../../modules/infra/i18n';

import { activeShop, getActiveBrandShops } from '../../../../auth/selectors';
import confirmModal from '../../../../common/confirmModal';
import { withActionByRole } from '../../../../common/helpers/actions';
import withNotifications from '../../../../common/withNotifications';
import * as actions from '../../actions';
import withBaseUrl from '../../hoc/withBaseUrl';
import * as selectors from '../../selectors';

const EditProductContainer = compose(
  withProps({
    isEditing: true,
    header: 'products:products.edit_button',
  }),
  connect((state, props) => ({
    product: selectors.byId(state, props.params.id),
    shops: getActiveBrandShops(state) || (activeShop(state) ? [activeShop(state)] : []),
  })),
  withRouter,
  withNotifications,
  withBaseUrl,
  withState('isModalOpened', 'setIsModalOpened', false),
  withHandlers({
    openModal: (props) => () => props.setIsModalOpened(true),
    closeModal: (props) => () => props.setIsModalOpened(false),
  }),
  withActionByRole('updateProduct', actions.updateShopItem, actions.updateBarberItem, actions.updateBrandItem),
  withActionByRole('deleteProduct', actions.deleteShopItem, actions.deleteBarberItem, actions.deleteBrandItem),
  withActionByRole('fetchProduct', actions.fetchShopItem, actions.fetchBarberItem, actions.fetchBrandItem),
  withHandlers({
    save: (props) => async (values) => {
      await props.updateProduct(props.params.id, values);
      props.addNotification({
        title: t('common:done'),
        level: 'success',
        message: t('products:products.update_success_message'),
      });
    },
    resetOverridesForShops: (props) => async (values) => {
      await props.updateProduct(props.params.id, values);
      props.addNotification({
        title: t('common:done'),
        level: 'success',
        message: t('products:products.overrides_reset_success_message'),
      });
    },
    deleteProduct: (props) => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: t('products:products.delete_modal.title'),
        message: t('products:products.delete_modal.message'),
      });

      if (confirmed) {
        props.deleteProduct(props.params.id);
        props.addNotification({
          title: t('common:done'),
          level: 'success',
          message: t('products:products.delete_success_message'),
        });
        props.router.push(props.baseUrl);
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchProduct(this.props.params.id);
    },
  }),
  branch((props) => !props.product, renderNothing),
  withProps((props) => {
    const assignments = (props.shops || []).reduce((memo, shop) => {
      const assignmentProps = (props.product.assignments || []).find((assignment) => assignment.ownerId === shop.id);
      const hasOwnerMatchedWithShop = props.product.ownerId === shop.id;

      return [
        ...memo,
        {
          ownerId: shop.id,
          enabled: !!assignmentProps || hasOwnerMatchedWithShop,
          name: shop.alias || shop.name,
          ...assignmentProps,
        },
      ];
    }, []);

    return {
      product: {
        ...props.product,
        assignments,
      },
      initialValues: {
        ...props.product,
        tax: map(props.product.taxes, 'id'),
        assignments: assignments.reduce(
          (memo, assignment) => ({
            ...memo,
            [assignment.ownerId]: assignment,
          }),
          {}
        ),
        inventory: selectors.getTotalInventory(props.product),
        unallocatedInventory: props.product.inventory,
        locationPrice: props.product.price,
        allEnabled: (assignments || []).every((assignment) => assignment.enabled),
      },
    };
  })
);

export default EditProductContainer;
